'use strict'

import React from 'react'

import './ConfirmHeader.less'

const ConfirmHeader = ({children, className}) => {
  return <div className={`${className}-header`}>
    {children}
  </div>
}

export default ConfirmHeader



// WEBPACK FOOTER //
// ../~/@master/webinfra-frontend-components/src/components/Confirm/ConfirmHeader/index.js